"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Droplets, Flame, ShieldAlert, Sparkles, MapPin, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
const serviceGroups = [{
  id: "water",
  title: "Water Damage Restoration",
  iconName: "droplets",
  description: "Rapid water extraction, structural drying, and moisture inspection."
}, {
  id: "fire",
  title: "Fire & Smoke Damage Restoration",
  iconName: "flame",
  description: "Soot mitigation, smoke deodorization, and structural stabilization."
}, {
  id: "mold",
  title: "Mold Remediation",
  iconName: "sparkles",
  description: "Safe containment, microbial abatement, and air quality restoration."
}, {
  id: "sewage",
  title: "Emergency Sewage Backup Cleanup",
  iconName: "shield-alert",
  description: "Category 3 sanitation, biohazard decontamination, and safe disposal."
}];
const serviceLinks = [
// Water Damage Restoration
{
  groupId: "water",
  city: "Bethesda",
  to: "https://triserveinc.com/emergency-water-damage-restoration-bethesda-md/"
}, {
  groupId: "water",
  city: "Silver Spring",
  to: "https://triserveinc.com/emergency-water-damage-restoration-silver-spring-md/"
}, {
  groupId: "water",
  city: "Rockville",
  to: "https://triserveinc.com/emergency-water-damage-restoration-rockville-md/"
}, {
  groupId: "water",
  city: "Gaithersburg",
  to: "https://triserveinc.com/emergency-water-damage-restoration-gaithersburg-md/"
}, {
  groupId: "water",
  city: "Germantown",
  to: "https://triserveinc.com/emergency-water-damage-restoration-germantown-md/"
}, {
  groupId: "water",
  city: "North Bethesda",
  to: "https://triserveinc.com/emergency-water-damage-restoration-north-bethesda-md/"
}, {
  groupId: "water",
  city: "Potomac",
  to: "https://triserveinc.com/emergency-water-damage-restoration-potomac-md/"
}, {
  groupId: "water",
  city: "Chevy Chase",
  to: "https://triserveinc.com/emergency-water-damage-restoration-chevy-chase-md/"
}, {
  groupId: "water",
  city: "Kensington",
  to: "https://triserveinc.com/emergency-water-damage-restoration-kensington-md/"
}, {
  groupId: "water",
  city: "Wheaton",
  to: "https://triserveinc.com/emergency-water-damage-restoration-wheaton-md/"
},
// Fire & Smoke Damage Restoration
{
  groupId: "fire",
  city: "Bethesda",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-bethesda-md/"
}, {
  groupId: "fire",
  city: "Silver Spring",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-silver-spring-md/"
}, {
  groupId: "fire",
  city: "Rockville",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-rockville-md/"
}, {
  groupId: "fire",
  city: "Gaithersburg",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-gaithersburg-md/"
}, {
  groupId: "fire",
  city: "Germantown",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-germantown-md/"
}, {
  groupId: "fire",
  city: "North Bethesda",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-north-bethesda-md/"
}, {
  groupId: "fire",
  city: "Potomac",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-potomac-md/"
}, {
  groupId: "fire",
  city: "Chevy Chase",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-chevy-chase-md/"
}, {
  groupId: "fire",
  city: "Kensington",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-kensington-md/"
}, {
  groupId: "fire",
  city: "Wheaton",
  to: "https://triserveinc.com/emergency-fire-smoke-damage-restoration-wheaton-md/"
},
// Mold Remediation
{
  groupId: "mold",
  city: "Bethesda",
  to: "https://triserveinc.com/mold-remediation-bethesda-md/"
}, {
  groupId: "mold",
  city: "Silver Spring",
  to: "https://triserveinc.com/mold-remediation-silver-spring-md/"
}, {
  groupId: "mold",
  city: "Rockville",
  to: "https://triserveinc.com/mold-remediation-rockville-md/"
}, {
  groupId: "mold",
  city: "Gaithersburg",
  to: "https://triserveinc.com/mold-remediation-gaithersburg-md/"
}, {
  groupId: "mold",
  city: "Germantown",
  to: "https://triserveinc.com/mold-remediation-germantown-md/"
}, {
  groupId: "mold",
  city: "North Bethesda",
  to: "https://triserveinc.com/mold-remediation-north-bethesda-md/"
}, {
  groupId: "mold",
  city: "Potomac",
  to: "https://triserveinc.com/mold-remediation-potomac-md/"
}, {
  groupId: "mold",
  city: "Chevy Chase",
  to: "https://triserveinc.com/mold-remediation-chevy-chase-md/"
}, {
  groupId: "mold",
  city: "Kensington",
  to: "https://triserveinc.com/mold-remediation-kensington-md/"
}, {
  groupId: "mold",
  city: "Wheaton",
  to: "https://triserveinc.com/mold-remediation-wheaton-md/"
},
// Emergency Sewage Backup Cleanup
{
  groupId: "sewage",
  city: "Bethesda",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-bethesda-md/"
}, {
  groupId: "sewage",
  city: "Silver Spring",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-silver-spring-md/"
}, {
  groupId: "sewage",
  city: "Rockville",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-rockville-md/"
}, {
  groupId: "sewage",
  city: "Gaithersburg",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-gaithersburg-md/"
}, {
  groupId: "sewage",
  city: "Germantown",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-germantown-md/"
}, {
  groupId: "sewage",
  city: "North Bethesda",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-north-bethesda-md/"
}, {
  groupId: "sewage",
  city: "Potomac",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-potomac-md/"
}, {
  groupId: "sewage",
  city: "Chevy Chase",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-chevy-chase-md/"
}, {
  groupId: "sewage",
  city: "Kensington",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-kensington-md/"
}, {
  groupId: "sewage",
  city: "Wheaton",
  to: "https://triserveinc.com/emergency-sewage-backup-cleanup-wheaton-md/"
}];
function renderServiceIcon(name: string) {
  switch (name) {
    case "droplets":
      return <Droplets className="size-5 text-primary" aria-hidden="true" />;
    case "flame":
      return <Flame className="size-5 text-primary" aria-hidden="true" />;
    case "sparkles":
      return <Sparkles className="size-5 text-primary" aria-hidden="true" />;
    case "shield-alert":
      return <ShieldAlert className="size-5 text-primary" aria-hidden="true" />;
    default:
      return <MapPin className="size-5 text-primary" aria-hidden="true" />;
  }
}
export default function Areas() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.06
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 12
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.1 : 0.32,
        ease: "easeOut"
      }
    }
  };
  return <section id="areasweserve" data-nav="light" className="bg-background py-16 sm:py-20 lg:py-24 border-t border-border">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mx-auto max-w-3xl text-center">
          <Badge variant="outline" className="mb-4 inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary border-border bg-muted/50 rounded-full">
            <Clock className="size-3.5 text-primary" aria-hidden="true" />
            24/7 Regional Emergency Dispatch
          </Badge>

          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Areas we serve
          </h2>

          <p className="mt-3 text-base sm:text-lg text-muted-foreground">
            Direct dispatch from local teams across Maryland, Washington DC, and Northern Virginia.
            Call our emergency specialists directly with no third-party call centers.
          </p>

          <p className="mt-3 text-base text-muted-foreground">
            TriServe serves customers across Maryland, Washington, DC, and Northern Virginia. We have dedicated local teams for the cities featured below and respond to restoration emergencies throughout our service area.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="https://triserveinc.com/maryland/" className="inline-flex items-center justify-center rounded-lg border border-border bg-card px-4 py-2 text-sm font-semibold text-foreground shadow-xs hover:border-primary hover:text-primary transition-colors duration-150 w-full sm:w-auto">
              Maryland
            </Link>
            <Link to="https://triserveinc.com/washington-dc/" className="inline-flex items-center justify-center rounded-lg border border-border bg-card px-4 py-2 text-sm font-semibold text-foreground shadow-xs hover:border-primary hover:text-primary transition-colors duration-150 w-full sm:w-auto">
              Washington, DC
            </Link>
            <Link to="https://triserveinc.com/northern-virginia/" className="inline-flex items-center justify-center rounded-lg border border-border bg-card px-4 py-2 text-sm font-semibold text-foreground shadow-xs hover:border-primary hover:text-primary transition-colors duration-150 w-full sm:w-auto">
              Northern Virginia
            </Link>
          </div>
        </div>

        {/* Featured Cities Subheading */}
        <h3 className="mt-10 sm:mt-12 text-center text-lg sm:text-xl font-bold tracking-tight text-foreground">
          Featured Cities With Dedicated Service Pages
        </h3>

        {/* 4-Column Directory Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.15
      }} className="mt-12 sm:mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {serviceGroups.map((group, groupIndex) => {
          const groupLinks = serviceLinks.filter(item => item.groupId === group.id);
          return <motion.article key={group.id} data-index={groupIndex} variants={itemVariants} className="flex flex-col rounded-xl border border-border bg-card p-6 shadow-xs hover:border-primary/40 transition-[border-color,box-shadow] duration-200">
                {/* Header for Category */}
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-muted border border-border">
                    {renderServiceIcon(group.iconName)}
                  </div>
                  <h3 className="text-base sm:text-lg font-semibold text-card-foreground leading-snug">
                    {group.title}
                  </h3>
                </div>

                <p className="mt-3 text-xs text-muted-foreground">
                  {group.description}
                </p>

                <div className="my-5 h-px w-full bg-border" aria-hidden="true" />

                {/* City Links List */}
                <ul className="flex flex-col space-y-2.5 text-sm" role="list">
                  {groupLinks.map((link, linkIndex) => <li key={`${group.id}-${link.city}`} data-index={linkIndex} className="flex items-center gap-2">
                      <MapPin className="size-3.5 shrink-0 text-muted-foreground/70" aria-hidden="true" />
                      <Link to={link.to} className="text-foreground/90 hover:text-primary transition-colors duration-150 underline-offset-4 hover:underline font-medium">
                        {link.city}
                      </Link>
                    </li>)}
                </ul>
              </motion.article>;
        })}
        </motion.div>

        {/* Local Dispatch Assurance Footnote */}
        <div className="mt-12 sm:mt-16 rounded-lg border border-border bg-muted/40 p-4 sm:p-6 text-center">
          <p className="text-xs sm:text-sm text-muted-foreground max-w-2xl mx-auto">
            Need immediate help in a surrounding town or neighborhood not listed? Our on-call
            teams service all adjacent Montgomery County and Washington Metro locations 24/7.
          </p>
        </div>
      </div>
    </section>;
}